import { ajaxFunc } from '../tools'
// 用户信息的接口
const membercontroller = {
  /****有关首页的接口****/
  //获取有关首页的接口
  index:ajaxFunc('/homeContent/index', 'post'),
  //首页预搜索接口
  result:ajaxFunc('/searchHistory/result', 'post'),
  //首页判断是否显示公告弹窗的数据
  pop:ajaxFunc('/nounce/pop', 'post', 1),
  message_deal:ajaxFunc('/message/message_deal', 'post', 1),
  /****有关登录注册模块的接口****/
  //获取注册登录背景图的接口
  getBg:ajaxFunc('/regPageBanner/get', 'post'),
  //密码登录
  password_login: ajaxFunc('/user/password_login', 'post'),
  //快捷登录
  code_login:ajaxFunc('/user/code_login', 'post'),
  //生成滑块拼图验证码
  creat_code:ajaxFunc('/validateCode/code', 'post'),
  //发送判断滑块拼图验证码是否成功
  send_code:ajaxFunc('/user/send_code', 'post'),
  //发起语音验证请求
  sendVoiceSms:ajaxFunc('/validateCode/sendVoiceSms', 'post'),
  //手机注册页面点击下一步调接口，后台做验证
  phoneRegister:ajaxFunc('/commonMember/phoneRegister', 'post'),
  //判断是否注册过手机号
  isExist:ajaxFunc('/commonMember/isExist', 'post'),
  //注册
  register:ajaxFunc('/user/register', 'post'),
  //设置昵称，头像上传自身单独调用的接口
  updateNickName:ajaxFunc('/commonMember/updateNickName', 'post'),
  /****有关我的店主的接口****/
  //我的店主
  user_store:ajaxFunc('/user/get_user_store', 'get'),
  //修改店主发送验证码
  store_send_code:ajaxFunc('/user/change_user_store_send_code', 'post'),
  //修改店主验证验证码
  user_store_verify:ajaxFunc('/user/change_user_store_verify', 'post'),
  //根据邀请码 invitation_code 获取用户信息
  by_invite:ajaxFunc('/user/get_user_info_by_invite', 'get'),
  //修改店主
  change_store:ajaxFunc('/user/change_user_store', 'post'),
  /****有关账户与安全的接口****/
  //账户安全里面的发送验证码和登录注册的发送验证码的接口一样  skey:1登录 2绑定 3换绑 4修改密码 5修改支付密码 6注册7实名认证
  // send_code，
  //验证原手机号或者邮箱，验证码是否正确 skey:1登录 2绑定 3换绑 4修改密码 5修改支付密码 6注册7实名认证
  validateCode:ajaxFunc('/validateCode/validateCode', 'post'),
  //语音验证码和登录注册的一样  skey:1登录 2绑定 3换绑 4修改密码 5修改支付密码 6注册7实名认证
  //sendVoiceSms
  //绑定手机号
  addMobile:ajaxFunc('/user/addMobile', 'post'),
  //修改手机号
  upMobile:ajaxFunc('/user/upMobile', 'post'),
  //绑定邮箱
  addEmail:ajaxFunc('/user/addEmail', 'post'),
  //修改邮箱
  upEmail:ajaxFunc('/user/upEmail', 'post'),
  //验证原密码
  verifyPwd:ajaxFunc('/user/verifyPwd', 'post'),
  //根据原密码设置密码
  upPwdByPwd:ajaxFunc('/user/upPwdByPwd', 'post'),
  //根据验证码设置密码
  upPwdByCode:ajaxFunc('/user/upPwdByCode', 'post'),
  //解绑微信
  untie:ajaxFunc('/commonMember/untie', 'post'),
  //绑定微信
  bindWx:ajaxFunc('/commonMember/bind', 'post'),
  /****有关地址管理页面的接口****/
  //获取收获地址列表
  getAddressList:ajaxFunc('/user/getAddressList', 'post'),
  //添加地址
  addAddress:ajaxFunc('/user/addAddress', 'post'),
  //获取收获地址详情
  getAddressInfo:ajaxFunc('/user/getAddressInfo', 'post'),
  //编辑地址
  upAddress:ajaxFunc('/user/upAddress', 'post'),
  //删除地址
  delAddress:ajaxFunc('/user/delAddress', 'post'),
  /****查看物流的接口****/
  //获取发货单下对应的商品
  getInvoiceGoods:ajaxFunc('/invoice/getInvoiceGoods', 'post'),
  //查看物流BC端共用
  getInvoiceList:ajaxFunc('/invoice/getInvoiceList', 'post'),
  //获取物流详情
  loginstic:ajaxFunc('/loginstic/info', 'post'),
  /****有关搜索的接口****/
  //搜索商品结果页、搜索
  getGoodslist:ajaxFunc('/goods/getGoodslist', 'post'),
  //搜索订单结果页、搜索
  getOrderList:ajaxFunc('/order/get_order_list', 'get'),
  //订单操作
  order_deal:ajaxFunc('/order/order_deal', 'post'),
  //搜索历史列表的接口
  searchHistory:ajaxFunc('/searchHistory/list', 'post'),
  //热门搜索
  hotGoods:ajaxFunc('/searchHistory/hotResult', 'post'),
  //清空搜索历史
  removeAll:ajaxFunc('/searchHistory/removeAll', 'post'),
  /****有关优惠券的接口****/
  //选择优惠券
  changeCoupons:ajaxFunc('/user/changeCoupons', 'get'),

  //new 优惠券接口（判断购物车跳转过来、立即购买）
  cartSettlement:ajaxFunc('/cart/cartSettlement', 'get'),
};

export default membercontroller;



// WEBPACK FOOTER //
// ./src/request/api/memberController.js